import { getOrderItems } from './get-order-items';
export const getOrderItemsByRewardId = (rewardId) => {
    return getOrderItems().filter(item => item.rewardId === rewardId);
};
